var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPause = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.75 4a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0V4zm6 0a.75.75 0 0 0-1.5 0v8a.75.75 0 0 0 1.5 0V4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPause);
export default ForwardRef;